/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAlignData = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 8.527a9.536 9.536 0 0 1-1.32.543c-1.755.585-4.117.93-6.68.93-2.563 0-4.925-.345-6.68-.93A9.536 9.536 0 0 1 4 8.527V12l.003.015a.295.295 0 0 0 .032.066c.043.07.13.174.291.301.33.26.87.539 1.626.79 1.07.357 2.464.626 4.048.75v2.006c-1.78-.129-3.393-.429-4.68-.858A9.53 9.53 0 0 1 4 14.527V18l.003.015a.295.295 0 0 0 .032.066c.043.07.13.173.291.301.33.26.87.539 1.626.79 1.07.357 2.464.626 4.048.75v2.006c-1.78-.129-3.393-.429-4.68-.858-.873-.29-1.651-.66-2.232-1.117C2.518 19.504 2 18.852 2 18V6c0-.852.519-1.504 1.088-1.953.581-.458 1.36-.826 2.232-1.117C7.075 2.345 9.437 2 12 2c2.563 0 4.925.345 6.68.93.873.29 1.651.66 2.232 1.117C21.482 4.496 22 5.148 22 6v4h-2zM4 6l.003.015a.296.296 0 0 0 .032.066c.043.07.13.174.291.301.33.26.87.539 1.626.79C7.454 7.674 9.592 8 12 8s4.546-.327 6.048-.827c.756-.252 1.296-.53 1.626-.79.162-.128.249-.232.29-.302a.293.293 0 0 0 .033-.066L20 6l-.003-.015a.293.293 0 0 0-.032-.066 1.235 1.235 0 0 0-.291-.301c-.33-.26-.87-.539-1.626-.79C16.546 4.326 14.408 4 12 4s-4.546.327-6.048.827c-.756.252-1.296.53-1.626.79a1.236 1.236 0 0 0-.29.302.296.296 0 0 0-.033.066L4 6zm8 16h10v-2H12z" />
        <path d="M22 18H12v-2h10zm-10-4h10v-2H12z" />
      </g>
    </g>
  </Icon>
);
export { SvgAlignData as AlignData };
